/* eslint-disable */
import { produce } from "immer";
import {
  SCHEME_PROTECTION_FETCH_FAILURE,
  SCHEME_PROTECTION_FETCH_START,
  SCHEME_PROTECTION_FETCH_SUCCESS,
} from "../actions/types";

const schemeProtection = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case SCHEME_PROTECTION_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case SCHEME_PROTECTION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case SCHEME_PROTECTION_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default schemeProtection;
